'use strict';
/**
 * This file is used for global fixes to meet ADA compliance
*/

var focus = require('./focus');
var accessibleTabs = require('./accessibleTabs');

/**
 * Add focus to skip to main content link
 */
// set tabindex
(function ($) {
    $('.skip-to-main-content-link').attr('tabindex', 0);
}(jQuery));

/**
 * Add class to close alerts on click-away
 */
$('body').click(function (event) {
    var $dismissible = $('.alert-dismissible').not('.fermat-cart-notification, .fermat-cart-error-notification');
    if ($dismissible.is(':visible') && !event.delegateTarget.classList.contains('modal-open')) {
        $dismissible.alert('close');
    }
});

/**
 * Handle accessibility of hidden product tile text
 */
if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $('.mini-description.grid-view .desc-content').addClass('sr-only');
    $('.mini-description').focusin(function () {
        $(this).find('.desc-content').removeClass('sr-only');
    });
    $('.mini-description').focusout(function () {
        $(this).find('.desc-content').addClass('sr-only');
    });
    $('.product-tile-wrapper').hover(function () {
        $(this).find('.mini-description.grid-view .desc-content').removeClass('sr-only');
    }, function () {
        $(this).find('.desc-content').addClass('sr-only');
    });
}


var ada = {
    trapModalFocus: focus.trapModalFocus('.modal'),
    focusFirstModalElementOnOpen: focus.focusFirstModalElementOnOpen,
    returnFocusOnModalClose: focus.returnFocusOnModalClose,
    accessibleTabs: accessibleTabs,
    /**
    * @desc Sets the non-active slides to hidden and their focusable elements to tab-index=-1
    * @param {Object} $slider - the slider to handle
    */
    accessbileSliders: function ($slider) {
        if (!$slider) {
            return;
        }
        $slider.find('.slick-dots button').removeAttr('aria-current');
        $slider.find('.slick-active > button').attr('aria-current', true);
        $slider.find('.slick-slide:not(.slick-active)').attr('aria-hidden', true);
        $slider.find('.slick-slide.slick-active').attr('aria-hidden', false);
        $slider.find('.slick-slide a, .slick-slide button').attr('tabindex', '-1');
        $slider.find('.slick-active a, .slick-active button').attr('tabindex', '0');
        if ($slider.has('.slick-dots button').length > 0) {
            var dotQty = $slider.find('.slick-dots button').length;
            $($slider.find('.slick-dots button')).each(function (index) {
                $(this).attr('aria-label', 'Carousel navigation link ' + (index + 1) + ' of ' + dotQty);
            });
        }
        // Observe changes to the active slide, generate an alt attr for the image zoom from active slide
        var $altOrigin;
        $('.product-carousel .slick-active').bind('DOMSubtreeModified', function () {
            $altOrigin = $('.slick-current.slick-active .zoom-hires .slide-img').attr('alt');
            if ($(this).find('.zoomImg')) $('.zoomImg').attr('alt', $altOrigin);
        });
    },
    /**
    * @desc Checks for video transcript links and verifies a file exists before displaying them to the user
    */
    videoTranscriptHelper: function () {
        var $transcriptLinks = $('.video-transcript-link');
        if ($transcriptLinks.length) {
            $transcriptLinks.each(function () {
                var $transcriptLink = $(this);
                var transcriptFileUrl = $transcriptLink.data('downloadsrc');
                $.get(transcriptFileUrl)
                    .done(function () {
                    // success! there is a file, show the link
                        $transcriptLink.removeClass('d-none');
                    })
                    .fail(function () {
                    // no file, ensure link does not show
                        $transcriptLink.addClass('d-none');
                    });
            });
        }
    }
};

module.exports = ada;
